import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from '../pages/Home';
import BookDetail from '../pages/BookDetail';
import Author from '../pages/Author';
import Seller from '../pages/Seller';
import SearchResults from '../pages/SearchResults';
import Cart from '../pages/Cart';
import SignUp from '../pages/SignUp';
import SignIn from '../pages/SignIn';
import Account from '../pages/Account';
import NotFound from '../pages/NotFound';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/libro/:id" component={BookDetail} />
      <Route exact path="/autor/:id" component={Author} />
      <Route exact path="/vendedor/:id" component={Seller} />
      <Route exact path="/buscar" component={SearchResults} />
      <Route exact path="/carrito" component={Cart} />
      <Route exact path="/registro" component={SignUp} />
      <Route exact path="/ingresar" component={SignIn} />
      <Route exact path="/cuenta" component={Account} />
      <Route component={NotFound} />
    </Switch>
  );
}
